<template>
  <div class="component-container">
    <span @click="openAction" class="button-link">サインイン</span>
    <ModalBackground v-if="isActive"/>
    <div v-if="isActive" class="modal-container" @click.self="closeModalAction">
      <div class="inner form-container">
        <div class="close-button-container" @click="closeModalAction">
          <CloseButton/>
        </div>
        <FormHelper @callback="callback" :formSettings="formSettings"/>
        <div class="forget-password-container">
          <div class="forget-password" @click="openForgetPasswordAction">
            <i class="fal fa-info-circle"></i>パスワードをお忘れの場合はこちら
          </div>
        </div>
      </div>
    </div>
    <UserForgetPassword v-if="isFPWActive" @callback="callback"/>
    <div v-if="$isDebug() && debugVerifyToken" class="debug-option-container">
      <router-link :to="{name: 'PasswordReset', params:{token: debugVerifyToken}}"
                   class="link">[DEBUG]メール認証
      </router-link>
    </div>
  </div>
</template>

<script>

import ModalBackground from '@/components/common/ModalBackground';
import FormHelper from '@/components/common/FormHelper';
import UserForgetPassword from '@/components/user/UserForgetPassword';
import CloseButton from '@/components/user/CloseButton';

export default {
  components: {
    ModalBackground,
    FormHelper,
    UserForgetPassword,
    CloseButton
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'auth',
        dispatch: 'login',
        header: 'サインイン',
        forms: {
          email: {
            label: 'メールアドレス',
            type: 'text',
            value: null,
            require: true,
            placeholder: 'mail@example.com',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          password: {
            label: 'パスワード',
            type: 'password',
            value: null,
            require: true,
            placeholder: '',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          holdPassword: {
            label: null,
            type: 'checkbox',
            value: [],
            require: true,
            placeholder: '',
            default: [true],
            validate: [],
            options: [
              {label: 'パスワードを保存', value: true}
            ],
            option: {
              size: 300,
            }
          }
        },
        useSessionId: false,
        submit: {
          label: 'サインイン',
          color: 'b'
        },
        info: [], // フォーム下部の補足説明
        reasonCode: {
          LOGIN_AUTH_ERROR: 'メールアドレスまたはパスワードが一致しません'
        },
        noValidationErrorMessage: true
      },
      isActive: false,
      // ----
      useHoldPassword: true,
      loginToken: null,
      cacheEmail: null,
      // ----
      isFPWActive: false,
      optionFW: {
        is1Button: true,
        buttonLabel: '閉じる',
        callback: 'OK1',
        callbackO: 'close',
        messages: ['入力されたメールアドレスにメールを送信しました', 'メールの内容をご確認ください']
      },
      debugVerifyToken: null
    };
  },
  created: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    lock: function () {

      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    }
  },
  methods: {
    initialize: function () {
      console.log('initialize');

      if (this.$route.name === 'SingIn') {
        this.isActive = true;
      }

    },
    openAction: function () {
      console.log('openDialog');

      let userId = this.$store.getters['auth/userId'];

      // すでに認証済みかチェック
      if (userId >= 1) {
        this.moveToHome();
        return;
      }

      console.log(this.$store.getters['auth/email']);

      this.useHoldPassword = this.$store.getters['auth/holdPassword'];

      if (this.useHoldPassword) {
        this.formSettings.forms.holdPassword.value[0] = true;
      }

      this.formSettings.forms.email.value = this.$store.getters['auth/email'];

      this.loginToken = this.$store.getters['auth/loginToken'];

      if (this.loginToken != null) {
        this.formSettings.forms.password.value = this.$store.getters['auth/defaultPassword'];
      }

      this.isActive = true;
    },
    closeModalAction: function () {
      console.log('closeDialog');
      this.isActive = false;
    },
    callback: function (dispatcher, value) {
      console.log('callback', dispatcher, value);

      if (dispatcher === 'FormHelperNotice') {
        // なにもしない
        return;
      } else if (dispatcher === 'FormHelperFinish') {
        this.moveToHome();
      } else if (dispatcher === 'pw_reset_close') {
        // 何もしない
      } else if (dispatcher === 'pw_reset_finish') {

        // 完了メッセージ
        this.$store.dispatch('message/open', this.optionFW).then();

        // -- デバッグリンク

        let response = this.$store.getters['user/response'];
        console.log(response.token);

        this.debugVerifyToken = response.token;
      }

      this.isFPWActive = false;
      this.isActive = false;

    },
    moveToHome: function () {
      // ホームへ遷移
      this.$router.push({name: 'Home'});
    },
    openForgetPasswordAction: function () {
      console.log('openForgetPasswordAction');

      // モーダル切り替え
      this.isFPWActive = true;
      this.isActive = false;

    }
  }
};

</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .component-container {
    display: inline-block;
  }

  .forget-password-container {
    text-align: center;

    .forget-password {
      display: inline-block;
      margin-top: 15px;
      font-size: 12px;
      cursor: pointer;
      border-bottom: 1px solid #ddd;
    }
  }

  .button-link{
    display: inline-block;
    width: 180px;
    height: 50px;
    line-height: 50px;
    background: $keyColor;
    border-radius: 25px;
    cursor: pointer;
    font-weight: bold;
    color: #fff;
    margin-bottom: 1px;

    &:hover {
      opacity: .8;
    }

    &:active {
      opacity: .6;
    }

  }

</style>
